import { useContext, useEffect, useState, useMemo, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import { InputMask } from "@react-input/mask";
import { MapContainer, TileLayer, Circle, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";

import "./style.css";
import { DasboardContext } from "../../context/dashboard-context";

// Leaflet varsayılan marker icon düzeltmesi
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
	iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
	shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

// Cihaz konumu için kırmızı marker
const deviceIcon = new L.Icon({
	iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
	shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41],
});

// Haritada tıklama ile merkez seçimi
function MapClickHandler({ onMapClick }) {
	useMapEvents({
		click(e) {
			onMapClick(e.latlng);
		},
	});
	return null;
}

// Harita merkezini değiştirmek için
function ChangeMapView({ center }) {
	const map = useMap();
	useEffect(() => {
		if (center) {
			map.setView(center, map.getZoom());
		}
	}, [center, map]);
	return null;
}

const DeviceDetailScreen = () => {
	const { usernames } = useContext(DasboardContext);
	const [deviceDetail, setDeviceDetail] = useState([]);
	const [loading, setLoading] = useState(true);
	const [updating, setUpdating] = useState(false);
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const [deviceID, setDeviceID] = useState("");
	const [organization, setOrganization] = useState("");
	const [person, setPerson] = useState("");
	const [status, setStatus] = useState("");
	const [brand, setBrand] = useState("");
	const [purchaseDate, setPurchaseDate] = useState("");
	const [installationDate, setInstallationDate] = useState("");
	const [location, setLocation] = useState("");
	const [room, setRoom] = useState("");
	const [floor, setFloor] = useState("");
	const [roomType, setRoomType] = useState("");
	const [roomName, setRoomName] = useState("");
	const [smsPhone, setSmsPhone] = useState([""]);
	const [suiteName, setSuiteName] = useState("");
	const [deviceNote, setDeviceNote] = useState("");
	const [simPhoneNumber, setSimPhoneNumber] = useState("");
	const [username, setUsername] = useState("");
	const [isDemo, setIsDemo] = useState(false);
	const [basement, setBasement] = useState();
	const [sosNumber, setSosNumber] = useState(["", "", "", ""]);
	const [updatingSos, setUpdatingSos] = useState(false);
	const [fallSensitivity, setFallSensitivity] = useState(3);
	const [updatingFallSensitivity, setUpdatingFallSensitivity] = useState(false);
	const [falldownEnabled, setFalldownEnabled] = useState(true);
	const [togglingFalldown, setTogglingFalldown] = useState(false);
	const [removeSmsEnabled, setRemoveSmsEnabled] = useState(true);
	const [togglingRemoveSms, setTogglingRemoveSms] = useState(false);
	const [safetyModeEnabled, setSafetyModeEnabled] = useState(false);
	const [togglingSafetyMode, setTogglingSafetyMode] = useState(false);
	const [talkingClockEnabled, setTalkingClockEnabled] = useState(false);
	const [togglingTalkingClock, setTogglingTalkingClock] = useState(false);
	const [pedometerEnabled, setPedometerEnabled] = useState(false);
	const [togglingPedometer, setTogglingPedometer] = useState(false);

	// Geofence (Güvenli Alan) state'leri
	const [geofenceCenter, setGeofenceCenter] = useState(null); // { lat, lng }
	const [geofenceRadius, setGeofenceRadius] = useState(500); // metre
	const [savingGeofence, setSavingGeofence] = useState(false);
	const [deviceLocation, setDeviceLocation] = useState(null); // { lat, lng, accuracy?, locationSource? }
	const [mapSearchQuery, setMapSearchQuery] = useState("");
	const [mapSearching, setMapSearching] = useState(false);
	const [mapSearchResults, setMapSearchResults] = useState([]);
	const [mapSearchError, setMapSearchError] = useState("");

	const handleMapSearch = useCallback(async () => {
		const query = mapSearchQuery.trim();
		if (!query) return;
		setMapSearching(true);
		setMapSearchResults([]);
		setMapSearchError("");
		try {
			const res = await fetch(
				`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&accept-language=tr`
			);
			if (!res.ok) {
				throw new Error(`HTTP ${res.status}`);
			}
			const data = await res.json();
			if (Array.isArray(data) && data.length > 0) {
				setMapSearchResults(data);
				const first = data[0];
				setGeofenceCenter({ lat: parseFloat(first.lat), lng: parseFloat(first.lon) });
			} else {
				setMapSearchError("Arama sonucu bulunamadı. Farklı bir adres deneyin.");
			}
		} catch (err) {
			console.error("Harita arama hatası:", err);
			setMapSearchError("Arama sırasında hata oluştu. Lütfen tekrar deneyin.");
		} finally {
			setMapSearching(false);
		}
	}, [mapSearchQuery]);

	// Ölçüm Zamanlama state'leri
	const [scheduleEnabled, setScheduleEnabled] = useState(false);
	const [scheduleType, setScheduleType] = useState("interval");
	const [scheduleInterval, setScheduleInterval] = useState(60);
	const [scheduleTimes, setScheduleTimes] = useState([]);
	const [newTime, setNewTime] = useState("");
	const [measureHeartRate, setMeasureHeartRate] = useState(true);
	const [measureTemperature, setMeasureTemperature] = useState(true);
	const [savingSchedule, setSavingSchedule] = useState(false);

	const [orgName, setOrgName] = useState();

	//For room count and floor count
	const [org, setOrg] = useState();
	const [floorCount, setFloorCount] = useState(0);
	const [roomCount, setRoomCount] = useState(0);

	const locations = ["Kurum", "Ev", "Depo", "Bakım"];
	const deviceStatus = ["Aktif", "Pasif", "Teknik Arıza"];
	const roomTypeSelect = [
		"Banyo",
		"Yatak Odası",
		"Aile Odası",
		"Koridor",
		"Mutfak",
		"Yemek Odası",
		"Oturma Odası",
		"Diğer",
	];

	const addPhoneNumber = () => {
		if (smsPhone.length < 6) {
			setSmsPhone([...smsPhone, ""]);
		}
	};

	const removePhoneNumber = (index) => {
		setSmsPhone(smsPhone.filter((_, i) => i !== index));
	};

	const handlePhoneNumberChange = (index, value) => {
		const newPhoneNumbers = [...smsPhone];
		newPhoneNumbers[index] = value;
		setSmsPhone(newPhoneNumbers);
	};

	const { id } = useParams();

	const getOrganisations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const organisationName = await response.json();
			setOrgName(organisationName);
			console.log(organisationName);
		} catch (error) {
			console.error("Veri getirilirken bir hata oluştu:", error);
		}
	};

	async function updateDevice() {
		setError("");
		setSuccess("");

		// Validasyonlar
		if (!deviceID?.trim()) {
			setError("Cihaz ID boş bırakılamaz.");
			return;
		}

		if (!organization?.trim()) {
			setError("Kurum adı seçilmelidir.");
			return;
		}

		if (!brand?.trim()) {
			setError("Cihaz markası boş bırakılamaz.");
			return;
		}

		try {
			setUpdating(true);
			const response = await fetch("https://app.vivasmartcare.com/api/device-update", {
				method: "PUT",
				body: JSON.stringify({
					id,
					deviceID,
					organization,
					person,
					status,
					brand,
					purchaseDate,
					installationDate,
					location,
					floor,
					room,
					roomName,
					smsPhone,
					suiteName,
					deviceNote,
					simPhoneNumber: simPhoneNumber.replace(/[_\s]/g, "").length > 3 ? simPhoneNumber.replace(/_/g, "") : "",
					roomType,
					isDemo: isDemo ? "true" : "false", // Backend String bekliyor
					sosNumber,
					fallSensitivity,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				setSuccess("Cihaz bilgileri başarıyla güncellendi.");
				setTimeout(() => {
					fetchData();
				}, 1000);
			} else {
				const data = await response.json();
				setError(data.message || "Cihaz güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			setError("Bağlantı hatası. Lütfen tekrar deneyin.");
		} finally {
			setUpdating(false);
		}
	}

	const fetchData = async () => {
		try {
			setLoading(true);
			setError("");
			const response = await fetch(`https://app.vivasmartcare.com/api/devices/${id}`);
			if (response.ok) {
				const devices = await response.json();
				setDeviceDetail(devices);
				setDeviceID(devices.deviceID);
				setOrganization(devices.organization);
				setPerson(devices.person);
				setStatus(devices.status);
				setBrand(devices.brand);
				setPurchaseDate(devices.purchaseDate);
				setInstallationDate(devices.installationDate);
				setLocation(devices.location);
				setUsername(devices.person);
				setFloor(devices.floor);
				setRoom(devices.room);
				setRoomName(devices.roomName);
				setSmsPhone(devices.smsPhone || [""]);
				setSuiteName(devices.suiteName);
				setDeviceNote(devices.deviceNote);
				setSimPhoneNumber(devices.simPhoneNumber || "");
				setRoomType(devices.roomType);
				// isDemo boolean'a çevir - backend String olarak saklıyor olabilir
				setIsDemo(
					devices.isDemo === true ||
					devices.isDemo === "true" ||
					devices.isDemo === 1 ||
					devices.isDemo === "1" ||
					devices.isDemo === "True"
				);
				if (devices.sosNumber) {
					const sosArr = Array.isArray(devices.sosNumber) ? [...devices.sosNumber] : [devices.sosNumber];
					while (sosArr.length < 4) sosArr.push("");
					setSosNumber(sosArr.slice(0, 4));
				} else {
					setSosNumber(["", "", "", ""]);
				}
				setFallSensitivity(devices.fallSensitivity || 3);
				setFalldownEnabled(devices.falldownEnabled !== undefined ? devices.falldownEnabled : true);
				setRemoveSmsEnabled(devices.removeSmsEnabled !== undefined ? devices.removeSmsEnabled : true);
				setSafetyModeEnabled(devices.safetyModeEnabled !== undefined ? devices.safetyModeEnabled : false);
				setTalkingClockEnabled(devices.talkingClockEnabled !== undefined ? devices.talkingClockEnabled : false);
				setPedometerEnabled(devices.pedometerEnabled !== undefined ? devices.pedometerEnabled : false);
				// Geofence verisi
				if (devices.geofence && devices.geofence.latitude && devices.geofence.longitude) {
					setGeofenceCenter({ lat: devices.geofence.latitude, lng: devices.geofence.longitude });
					setGeofenceRadius(devices.geofence.radius || 500);
				}
				// Cihaz son konumunu al (V04T/Vivistar ise)
				if (devices.brand === "V04T" || devices.brand === "Vivistar") {
					try {
						const locRes = await fetch(`https://app.vivasmartcare.com/api/v46-location/${devices.deviceID}`);
						if (locRes.ok) {
							const locData = await locRes.json();
							if (locData && locData.location && locData.location.latitude && locData.location.longitude) {
								setDeviceLocation({
									lat: locData.location.latitude,
									lng: locData.location.longitude,
									accuracy: locData.location.accuracy || 0,
									locationSource: locData.locationSource || "gps",
								});
							}
						}
					} catch (err) {
						console.error("Cihaz konumu alınamadı:", err);
					}
					// Ölçüm zamanlama ayarlarını al
					try {
						const schedRes = await fetch(`https://app.vivasmartcare.com/api/v04t-measurement-schedule/${devices.deviceID}`);
						if (schedRes.ok) {
							const schedData = await schedRes.json();
							if (schedData.schedule) {
								setScheduleEnabled(schedData.schedule.enabled || false);
								setScheduleType(schedData.schedule.type || "interval");
								setScheduleInterval(schedData.schedule.intervalMinutes || 60);
								setScheduleTimes(schedData.schedule.times || []);
								setMeasureHeartRate(schedData.schedule.measurements?.heartRate !== false);
								setMeasureTemperature(schedData.schedule.measurements?.temperature || false);
							}
						}
					} catch (err) {
						console.error("Ölçüm zamanlama alınamadı:", err);
					}
				}
			} else {
				setError("Cihaz bilgileri yüklenirken bir hata oluştu.");
			}
		} catch (error) {
			console.error("Error fetching device data:", error);
			setError("Bağlantı hatası. Lütfen tekrar deneyin.");
		} finally {
			setLoading(false);
		}
	};

	async function deleteDevice() {
		try {
			const response = await fetch("https://app.vivasmartcare.com/api/device", {
				method: "DELETE",
				body: JSON.stringify({
					id,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Cihaz Silindi");
				window.location.href = "/devices";
			} else {
				alert("Cihaz silinirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Silme işlemi sırasında bir hata oluştu:", error);
		}
	}

	useEffect(() => {
		getOrganisations();
	}, []);

	useEffect(() => {
		fetchData();
		// Cihaz V04T ise açılışta otomatik hassasiyet ve düşme durumu sorgusu gönder
		if (id && (brand === "V04T" || brand === "Vivistar")) {
			const queryDeviceSettings = async () => {
				try {
					// Hassasiyet sorgula
					await fetch("https://app.vivasmartcare.com/api/v04t-query-fall-sensitivity", {
						method: "POST",
						body: JSON.stringify({ deviceId: deviceID }),
						headers: { "Content-Type": "application/json" },
					});

					// Düşme bildirimi durumu sorgula
					await fetch("https://app.vivasmartcare.com/api/v04t-query-falldown-status", {
						method: "POST",
						body: JSON.stringify({ deviceId: deviceID }),
						headers: { "Content-Type": "application/json" },
					});

					// Cihazın yanıt verip DB'yi güncellemesi için 3 saniye bekle ve veriyi tekrar çek
					setTimeout(() => {
						fetchData();
					}, 3000);
				} catch (err) {
					console.error("Otomatik cihaz ayarları sorgu hatası:", err);
				}
			};
			queryDeviceSettings();
		}
	}, [id, brand === "V04T" || brand === "Vivistar"]);

	useEffect(() => {
		const selectedOrg = orgName?.find(
			(org) => org.organisationName === organization
		);
		setOrg(selectedOrg);
		setFloorCount(parseInt(selectedOrg?.organisationFloors));
		setBasement(parseInt(selectedOrg?.organisationBasements));
		setRoomCount(parseInt(selectedOrg?.organisationRooms));
	}, [organization]);

	if (loading) {
		return (
			<div className="device-detail-loading">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Yükleniyor...</span>
				</div>
				<p>Cihaz bilgileri yükleniyor...</p>
			</div>
		);
	}

	return (
		<div className="user-detail-screen">
			<div className="device-detail-header">
				<h2>Cihaz Detayları</h2>
				<p className="device-detail-subtitle">
					Cihaz bilgilerini buradan görüntüleyebilir ve güncelleyebilirsiniz.
				</p>
			</div>

			{/* Hata ve Başarı Mesajları */}
			{error && (
				<div className="alert alert-danger" role="alert">
					{error}
				</div>
			)}
			{success && (
				<div className="alert alert-success" role="alert">
					{success}
				</div>
			)}

			<div className="device-info-wrapper">
				<div className="info">
					<span>Cihaz ID:</span>
					<Form.Control
						type="text"
						value={deviceID}
						onChange={(e) => setDeviceID(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Kurum Adı:</span>
					<Form.Select onChange={(e) => setOrganization(e.target.value)}>
						{orgName?.map((org, index) => (
							<option
								value={org.organisationName}
								key={index}
								selected={org.organisationName === organization && "true"}
							>
								{org.organisationName}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Cihaz Markası</span>
					<Form.Select value={brand} onChange={(e) => setBrand(e.target.value)}>
						<option value="Vayyar">Düşme Cihazı</option>
						<option value="Viva02P">Viva02P</option>
						<option value="Viva03D">Viva03D</option>
						<option value="Vivistar">V04T</option>
					</Form.Select>
				</div>
				<div className="info">
					<span>Kullanıcı Adı:</span>
					<Form.Select onChange={(e) => setPerson(e.target.value)}>
						{usernames?.map((username, index) => (
							<option
								value={username.userName}
								key={index}
								selected={username.userName === person && "true"}
							>
								{username.userName}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Cihaz Durumu:</span>
					<Form.Select
						value={status}
						onChange={(e) => setStatus(e.target.value)}
					>
						{deviceStatus.map((dStatu, index) => (
							<option
								value={dStatu}
								key={index}
								selected={status === dStatu && "true"}
							>
								{dStatu}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Satın Alma Tarihi</span>
					<Form.Control
						type="text"
						value={purchaseDate}
						onChange={(e) => setPurchaseDate(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Kurulum Tarihi:</span>
					<Form.Control
						type="text"
						value={installationDate}
						onChange={(e) => setInstallationDate(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Konum:</span>
					<Form.Select onChange={(e) => setLocation(e.target.value)}>
						{locations.map((loc, index) => (
							<option
								value={loc}
								key={index}
								selected={location === loc ? "true" : "false"}
							>
								{loc}
							</option>
						))}
					</Form.Select>
				</div>
				{location === "Kurum" && (
					<div className="info">
						<span>Süit Bilgisi:</span>
						<Form.Control
							type="text"
							placeholder="Süit Bilgisi"
							value={suiteName}
							onChange={(e) => setSuiteName(e.target.value)}
						/>
					</div>
				)}
				<div className="info">
					<span>Bulunduğu Kat:</span>
					<Form.Select
						required
						value={floor}
						onChange={(e) => setFloor(e.target.value)}
					>
						<option>Kat Seçiniz:</option>

						{floorCount > 0 && (
							<>
								{typeof basement === "number" && basement < 0
									? Array.from(
										{ length: floorCount - basement + 1 },
										(_, index) => basement + index
									).map((currentFloor) => (
										<option
											key={currentFloor}
											value={currentFloor}
											selected={floor == currentFloor}
										>
											{currentFloor === 0
												? "Zemin Kat"
												: `${currentFloor}. Kat`}
										</option>
									))
									: Array.from(
										{ length: floorCount },
										(_, index) => index + 1
									).map((currentFloor) => (
										<option
											key={currentFloor}
											value={currentFloor}
											selected={floor == currentFloor}
										>
											{currentFloor}. Kat
										</option>
									))}
							</>
						)}
					</Form.Select>
				</div>

				{location === "Kurum" || location === "Ev" ? (
					<div className="info">
						<span>Oda Tipi</span>
						<Form.Select
							required
							value={roomType}
							onChange={(e) => setRoomType(e.target.value)}
						>
							{roomTypeSelect.map((room, index) => (
								<option value={room} key={index} selected={room === roomType}>
									{room}
								</option>
							))}
						</Form.Select>
					</div>
				) : (
					<div className="info">
						<span>Bulunduğu Oda:</span>
						<Form.Select
							required
							value={room}
							onChange={(e) => setRoom(e.target.value)}
						>
							<option>Oda Seçiniz:</option>
							{roomCount &&
								roomCount > 0 &&
								[...Array(roomCount).keys()].map((roomCount, index) => (
									<option
										key={index + 1}
										value={index + 1}
										selected={room == index + 1}
									>
										{index + 1}. Oda
									</option>
								))}
						</Form.Select>
					</div>
				)}
				<div className="info">
					<span>Oda İsmi:</span>
					<Form.Control
						type="text"
						required
						value={roomName}
						onChange={(e) => setRoomName(e.target.value)}
					/>
				</div>
				<div className="info phone-numbers-section">
					<span>Bildirim Alan Numara:</span>
					{smsPhone.map((phoneNumber, index) => (
						<div key={index} className="phone-number-row">
							<InputMask
								mask="+90__________"
								replacement={{ _: /\d/ }}
								value={phoneNumber}
								showMask
								onChange={(e) => handlePhoneNumberChange(index, e.target.value)}
								className="phone-input"
							/>
							{smsPhone.length < 6 && index === smsPhone.length - 1 && (
								<Button
									variant="primary"
									onClick={addPhoneNumber}
									className="btn-add-phone"
								>
									Ekle
								</Button>
							)}
							{index > 0 && (
								<Button
									variant="danger"
									onClick={() => removePhoneNumber(index)}
									className="btn-remove-phone"
								>
									Çıkart
								</Button>
							)}
						</div>
					))}
				</div>
				{(brand === "V04T" || brand === "Vivistar") && (
					<div className="info sos-number-section">
						<span>SOS Numarası (V04T):</span>
						<div className="sos-numbers-grid">
							{Array.isArray(sosNumber) && sosNumber.map((num, index) => (
								<div key={index} className="sos-number-item">
									<small className="text-muted">SOS {index + 1}</small>
									<InputMask
										mask="+90__________"
										replacement={{ _: /\d/ }}
										value={num}
										showMask
										onChange={(e) => {
											const newSos = [...sosNumber];
											newSos[index] = e.target.value;
											setSosNumber(newSos);
										}}
										className="sos-input"
										placeholder="+90XXXXXXXXXX"
									/>
								</div>
							))}
							<Button
								variant="success"
								onClick={async () => {
									// En az bir numara dolu olmalı
									if (sosNumber.every(num => !num.replace(/\D/g, ""))) {
										setError("En az bir SOS numarası girilmelidir.");
										return;
									}

									try {
										setUpdatingSos(true);
										setError("");
										setSuccess("");

										const response = await fetch(
											"https://app.vivasmartcare.com/api/v04t-update-sos",
											{
												method: "POST",
												body: JSON.stringify({
													deviceId: deviceID,
													sosNumber: sosNumber,
												}),
												headers: { "Content-Type": "application/json" },
											}
										);

										const data = await response.json();

										if (response.ok) {
											setSuccess(
												data.message || "SOS numaraları başarıyla güncellendi."
											);
											setTimeout(() => {
												fetchData();
											}, 1000);
										} else {
											setError(
												data.error ||
												"SOS numaraları güncellenirken bir hata oluştu"
											);
										}
									} catch (error) {
										console.error("SOS numaraları güncelleme hatası:", error);
										setError("Bağlantı hatası. Lütfen tekrar deneyin.");
									} finally {
										setUpdatingSos(false);
									}
								}}
								disabled={updatingSos}
								className="btn-update-sos"
							>
								{updatingSos ? (
									<>
										<span
											className="spinner-border spinner-border-sm me-2"
											role="status"
											aria-hidden="true"
										></span>
										Güncelleniyor...
									</>
								) : (
									"SOS Numaralarını Güncelle"
								)}
							</Button>
						</div>
						<small className="text-muted">
							V04T cihazları için 4 adede kadar SOS numarası tanımlayabilirsiniz.
						</small>
					</div>
				)}
				{(brand === "V04T" || brand === "Vivistar") && (
					<>
						<div className="info falldown-toggle-section">
							<span>Düşme Bildirimi (V04T):</span>
							<div className="falldown-toggle-wrapper">
								<div className="falldown-toggle-buttons">
									<Button
										variant={falldownEnabled ? "success" : "outline-success"}
										onClick={async () => {
											if (falldownEnabled) return; // Zaten açık
											try {
												setTogglingFalldown(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-falldown",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: true,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setFalldownEnabled(true);
													setSuccess(
														data.message || "Düşme bildirimi başarıyla açıldı."
													);
												} else {
													setError(
														data.error ||
														"Düşme bildirimi açılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Düşme bildirimi açma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingFalldown(false);
											}
										}}
										disabled={togglingFalldown}
										className="btn-falldown-on"
									>
										{togglingFalldown && falldownEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Açılıyor...
											</>
										) : (
											"Aç"
										)}
									</Button>
									<Button
										variant={!falldownEnabled ? "danger" : "outline-danger"}
										onClick={async () => {
											if (!falldownEnabled) return; // Zaten kapalı
											try {
												setTogglingFalldown(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-falldown",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: false,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setFalldownEnabled(false);
													setSuccess(
														data.message || "Düşme bildirimi başarıyla kapatıldı."
													);
												} else {
													setError(
														data.error ||
														"Düşme bildirimi kapatılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Düşme bildirimi kapatma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingFalldown(false);
											}
										}}
										disabled={togglingFalldown}
										className="btn-falldown-off"
									>
										{togglingFalldown && !falldownEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Kapatılıyor...
											</>
										) : (
											"Kapat"
										)}
									</Button>
								</div>
								<div className="falldown-status">
									<span className={`status-indicator ${falldownEnabled ? 'status-on' : 'status-off'}`}>
										{falldownEnabled ? '● Açık' : '○ Kapalı'}
									</span>
								</div>
							</div>
							<small className="text-muted">
								Düşme algılama özelliğini açın veya kapatın. Açık olduğunda cihaz düşme olaylarını tespit edip bildirim gönderir.
							</small>
						</div>

						<div className="info falldown-toggle-section">
							<span>Saat Çıkarma Alarmı (V04T):</span>
							<div className="falldown-toggle-wrapper">
								<div className="falldown-toggle-buttons">
									<Button
										variant={removeSmsEnabled ? "success" : "outline-success"}
										onClick={async () => {
											if (removeSmsEnabled) return;
											try {
												setTogglingRemoveSms(true);
												setError("");
												setSuccess("");
												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-removesms",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: true,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);
												const data = await response.json();
												if (response.ok) {
													setRemoveSmsEnabled(true);
													setSuccess(data.message || "Saat çıkarma alarmı açıldı.");
												} else {
													setError(data.error || "Saat çıkarma alarmı açılamadı.");
												}
											} catch (err) {
												console.error("Saat çıkarma alarmı açma hatası:", err);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingRemoveSms(false);
											}
										}}
										disabled={togglingRemoveSms}
										className="btn-falldown-on"
									>
										{togglingRemoveSms && removeSmsEnabled ? (
											<>
												<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												Açılıyor...
											</>
										) : (
											"Aç"
										)}
									</Button>
									<Button
										variant={!removeSmsEnabled ? "danger" : "outline-danger"}
										onClick={async () => {
											if (!removeSmsEnabled) return;
											try {
												setTogglingRemoveSms(true);
												setError("");
												setSuccess("");
												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-removesms",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: false,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);
												const data = await response.json();
												if (response.ok) {
													setRemoveSmsEnabled(false);
													setSuccess(data.message || "Saat çıkarma alarmı kapatıldı.");
												} else {
													setError(data.error || "Saat çıkarma alarmı kapatılamadı.");
												}
											} catch (err) {
												console.error("Saat çıkarma alarmı kapatma hatası:", err);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingRemoveSms(false);
											}
										}}
										disabled={togglingRemoveSms}
										className="btn-falldown-off"
									>
										{togglingRemoveSms && !removeSmsEnabled ? (
											<>
												<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												Kapatılıyor...
											</>
										) : (
											"Kapat"
										)}
									</Button>
								</div>
								<div className="falldown-status">
									<span className={`status-indicator ${removeSmsEnabled ? 'status-on' : 'status-off'}`}>
										{removeSmsEnabled ? '● Açık' : '○ Kapalı'}
									</span>
								</div>
							</div>
							<small className="text-muted">
								Açık olduğunda saat bilekten çıkarıldığında cihaz alarm gönderir. Kapatılırsa saatin bilekte olup olmadığı anlaşılmaz.
							</small>
						</div>

						<div className="info safety-mode-section">
							<span>Güvenli Mod (V04T):</span>
							<div className="falldown-toggle-wrapper">
								<div className="falldown-toggle-buttons">
									<Button
										variant={safetyModeEnabled ? "success" : "outline-success"}
										onClick={async () => {
											if (safetyModeEnabled) return;
											try {
												setTogglingSafetyMode(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-safety-mode",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: true,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setSafetyModeEnabled(true);
													setSuccess(
														data.message || "Güvenli mod başarıyla açıldı."
													);
												} else {
													setError(
														data.error ||
														"Güvenli mod açılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Güvenli mod açma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingSafetyMode(false);
											}
										}}
										disabled={togglingSafetyMode}
										className="btn-falldown-on"
									>
										{togglingSafetyMode && safetyModeEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Açılıyor...
											</>
										) : (
											"Aç"
										)}
									</Button>
									<Button
										variant={!safetyModeEnabled ? "danger" : "outline-danger"}
										onClick={async () => {
											if (!safetyModeEnabled) return;
											try {
												setTogglingSafetyMode(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-safety-mode",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: false,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setSafetyModeEnabled(false);
													setSuccess(
														data.message || "Güvenli mod başarıyla kapatıldı."
													);
												} else {
													setError(
														data.error ||
														"Güvenli mod kapatılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Güvenli mod kapatma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingSafetyMode(false);
											}
										}}
										disabled={togglingSafetyMode}
										className="btn-falldown-off"
									>
										{togglingSafetyMode && !safetyModeEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Kapatılıyor...
											</>
										) : (
											"Kapat"
										)}
									</Button>
								</div>
								<div className="falldown-status">
									<span className={`status-indicator ${safetyModeEnabled ? 'status-on' : 'status-off'}`}>
										{safetyModeEnabled ? '● Açık' : '○ Kapalı'}
									</span>
								</div>
							</div>
							<small className="text-muted">
								Güvenli mod açıldığında cihaz sadece rehberdeki numaralardan gelen aramaları kabul eder.
							</small>
						</div>

						<div className="info safety-mode-section">
							<span>Konuşan Saat (V04T):</span>
							<div className="falldown-toggle-wrapper">
								<div className="falldown-toggle-buttons">
									<Button
										variant={talkingClockEnabled ? "success" : "outline-success"}
										onClick={async () => {
											if (talkingClockEnabled) return;
											try {
												setTogglingTalkingClock(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-talking-clock",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: true,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setTalkingClockEnabled(true);
													setSuccess(
														data.message || "Konuşan saat başarıyla açıldı."
													);
												} else {
													setError(
														data.error ||
														"Konuşan saat açılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Konuşan saat açma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingTalkingClock(false);
											}
										}}
										disabled={togglingTalkingClock}
										className="btn-falldown-on"
									>
										{togglingTalkingClock && talkingClockEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Açılıyor...
											</>
										) : (
											"Aç"
										)}
									</Button>
									<Button
										variant={!talkingClockEnabled ? "danger" : "outline-danger"}
										onClick={async () => {
											if (!talkingClockEnabled) return;
											try {
												setTogglingTalkingClock(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-talking-clock",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: false,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setTalkingClockEnabled(false);
													setSuccess(
														data.message || "Konuşan saat başarıyla kapatıldı."
													);
												} else {
													setError(
														data.error ||
														"Konuşan saat kapatılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Konuşan saat kapatma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingTalkingClock(false);
											}
										}}
										disabled={togglingTalkingClock}
										className="btn-falldown-off"
									>
										{togglingTalkingClock && !talkingClockEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Kapatılıyor...
											</>
										) : (
											"Kapat"
										)}
									</Button>
								</div>
								<div className="falldown-status">
									<span className={`status-indicator ${talkingClockEnabled ? 'status-on' : 'status-off'}`}>
										{talkingClockEnabled ? '● Açık' : '○ Kapalı'}
									</span>
								</div>
							</div>
							<small className="text-muted">
								Konuşan saat açıldığında cihaz saati sesli olarak bildirir.
							</small>
						</div>

						<div className="info safety-mode-section">
							<span>Adım Sayar (V04T):</span>
							<div className="falldown-toggle-wrapper">
								<div className="falldown-toggle-buttons">
									<Button
										variant={pedometerEnabled ? "success" : "outline-success"}
										onClick={async () => {
											if (pedometerEnabled) return;
											try {
												setTogglingPedometer(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-pedometer",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: true,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setPedometerEnabled(true);
													setSuccess(
														data.message || "Adım sayar başarıyla açıldı."
													);
												} else {
													setError(
														data.error ||
														"Adım sayar açılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Adım sayar açma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingPedometer(false);
											}
										}}
										disabled={togglingPedometer}
										className="btn-falldown-on"
									>
										{togglingPedometer && pedometerEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Açılıyor...
											</>
										) : (
											"Aç"
										)}
									</Button>
									<Button
										variant={!pedometerEnabled ? "danger" : "outline-danger"}
										onClick={async () => {
											if (!pedometerEnabled) return;
											try {
												setTogglingPedometer(true);
												setError("");
												setSuccess("");

												const response = await fetch(
													"https://app.vivasmartcare.com/api/v04t-toggle-pedometer",
													{
														method: "POST",
														body: JSON.stringify({
															deviceId: deviceID,
															enabled: false,
														}),
														headers: { "Content-Type": "application/json" },
													}
												);

												const data = await response.json();

												if (response.ok) {
													setPedometerEnabled(false);
													setSuccess(
														data.message || "Adım sayar başarıyla kapatıldı."
													);
												} else {
													setError(
														data.error ||
														"Adım sayar kapatılırken bir hata oluştu"
													);
												}
											} catch (error) {
												console.error("Adım sayar kapatma hatası:", error);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setTogglingPedometer(false);
											}
										}}
										disabled={togglingPedometer}
										className="btn-falldown-off"
									>
										{togglingPedometer && !pedometerEnabled ? (
											<>
												<span
													className="spinner-border spinner-border-sm me-2"
													role="status"
													aria-hidden="true"
												></span>
												Kapatılıyor...
											</>
										) : (
											"Kapat"
										)}
									</Button>
								</div>
								<div className="falldown-status">
									<span className={`status-indicator ${pedometerEnabled ? 'status-on' : 'status-off'}`}>
										{pedometerEnabled ? '● Açık' : '○ Kapalı'}
									</span>
								</div>
							</div>
							<small className="text-muted">
								Adım sayar açıldığında cihaz günlük adım sayısını takip eder.
							</small>
						</div>

						<div className="info geofence-section">
							<span>Güvenli Alan (V04T):</span>
							<div className="geofence-map-wrapper">
								<div className="geofence-search">
									<div className="geofence-search-input">
										<input
											type="text"
											placeholder="Adres veya konum ara... (örn: Üsküdar Burhaniye)"
											value={mapSearchQuery}
											onChange={(e) => setMapSearchQuery(e.target.value)}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													e.preventDefault();
													handleMapSearch();
												}
											}}
											className="geofence-search-field"
										/>
										<Button
											variant="primary"
											type="button"
											disabled={mapSearching || !mapSearchQuery.trim()}
											className="geofence-search-btn"
											onClick={handleMapSearch}
										>
											{mapSearching ? (
												<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
											) : (
												"Ara"
											)}
										</Button>
									</div>
									{mapSearchError && (
										<div className="geofence-search-error">
											{mapSearchError}
										</div>
									)}
									{mapSearchResults.length > 0 && (
										<div className="geofence-search-results">
											{mapSearchResults.map((result, idx) => (
												<div
													key={idx}
													className="geofence-search-result-item"
													onClick={() => {
														setGeofenceCenter({ lat: parseFloat(result.lat), lng: parseFloat(result.lon) });
														setMapSearchResults([]);
													}}
												>
													{result.display_name}
												</div>
											))}
										</div>
									)}
								</div>
								<MapContainer
									center={geofenceCenter || deviceLocation || [39.9334, 32.8597]}
									zoom={15}
									className="geofence-map"
								>
									<TileLayer
										attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
										url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
									/>
									<MapClickHandler onMapClick={(latlng) => setGeofenceCenter(latlng)} />
									{geofenceCenter && (
										<ChangeMapView center={geofenceCenter} />
									)}
									{geofenceCenter && (
										<>
											<Marker position={geofenceCenter} />
											<Circle
												center={geofenceCenter}
												radius={Number(geofenceRadius) || 500}
												pathOptions={{ color: "blue", fillColor: "blue", fillOpacity: 0.1 }}
											/>
										</>
									)}
									{deviceLocation && (
										<>
											<Marker position={deviceLocation} icon={deviceIcon} />
											{deviceLocation.locationSource && deviceLocation.locationSource !== "gps" && deviceLocation.accuracy > 0 && (
												<Circle
													center={deviceLocation}
													radius={deviceLocation.accuracy}
													pathOptions={{
														color: "#f59e0b",
														fillColor: "#f59e0b",
														fillOpacity: 0.12,
														weight: 2,
														dashArray: "6 4",
													}}
												/>
											)}
										</>
									)}
								</MapContainer>

								{deviceLocation && deviceLocation.locationSource && deviceLocation.locationSource !== "gps" && (
									<div style={{
										display: "flex",
										alignItems: "center",
										gap: "8px",
										padding: "8px 12px",
										marginTop: "8px",
										background: "#fffbeb",
										border: "1px solid #fde68a",
										borderRadius: "8px",
										fontSize: "13px",
										color: "#92400e",
									}}>
										<span style={{ fontSize: "16px" }}>&#x1F4F6;</span>
										<span>
											Konum <strong>{deviceLocation.locationSource === "wifi" ? "WiFi" : "Baz İstasyonu (LBS)"}</strong> ile belirlendi
											{deviceLocation.accuracy > 0 && ` — Doğruluk: ~${Math.round(deviceLocation.accuracy)}m`}
										</span>
									</div>
								)}

								<div className="geofence-controls">
									<div className="geofence-radius-input">
										<label>Yarıçap (metre):</label>
										<input
											type="number"
											min="50"
											max="10000"
											value={geofenceRadius}
											onChange={(e) => {
												const val = e.target.value;
												if (val === "") {
													setGeofenceRadius("");
												} else {
													const num = parseInt(val, 10);
													if (!isNaN(num)) setGeofenceRadius(num);
												}
											}}
											onBlur={(e) => {
												const num = parseInt(e.target.value, 10);
												if (isNaN(num) || num < 50) {
													setGeofenceRadius(50);
												} else if (num > 10000) {
													setGeofenceRadius(10000);
												}
											}}
											className="form-control"
										/>
									</div>
									<div className="geofence-buttons">
										<Button
											variant="success"
											onClick={async () => {
												if (!geofenceCenter) {
													setError("Lütfen haritada bir merkez noktası seçin.");
													return;
												}
												try {
													setSavingGeofence(true);
													setError("");
													setSuccess("");
													const response = await fetch(
														"https://app.vivasmartcare.com/api/v04t-update-geofence",
														{
															method: "POST",
															body: JSON.stringify({
																deviceId: deviceID,
																latitude: geofenceCenter.lat,
																longitude: geofenceCenter.lng,
																radius: Number(geofenceRadius) || 500,
															}),
															headers: { "Content-Type": "application/json" },
														}
													);
													const data = await response.json();
													if (response.ok) {
														setSuccess(data.message || "Güvenli alan kaydedildi.");
													} else {
														setError(data.error || "Güvenli alan kaydedilirken hata oluştu.");
													}
												} catch (err) {
													console.error("Geofence kaydetme hatası:", err);
													setError("Bağlantı hatası. Lütfen tekrar deneyin.");
												} finally {
													setSavingGeofence(false);
												}
											}}
											disabled={savingGeofence || !geofenceCenter}
										>
											{savingGeofence ? (
												<>
													<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													Kaydediliyor...
												</>
											) : (
												"Güvenli Alanı Kaydet"
											)}
										</Button>
										{geofenceCenter && (
											<Button
												variant="outline-danger"
												onClick={async () => {
													try {
														setError("");
														setSuccess("");
														const response = await fetch(
															"https://app.vivasmartcare.com/api/v04t-delete-geofence",
															{
																method: "POST",
																body: JSON.stringify({ deviceId: deviceID }),
																headers: { "Content-Type": "application/json" },
															}
														);
														const data = await response.json();
														if (response.ok) {
															setGeofenceCenter(null);
															setSuccess(data.message || "Güvenli alan silindi.");
														} else {
															setError(data.error || "Güvenli alan silinirken hata oluştu.");
														}
													} catch (err) {
														console.error("Geofence silme hatası:", err);
														setError("Bağlantı hatası.");
													}
												}}
											>
												Güvenli Alanı Sil
											</Button>
										)}
									</div>
								</div>
							</div>
							<small className="text-muted">
								Haritada tıklayarak güvenli alan merkezi belirleyin. Mavi işaretçi güvenli alan merkezini, kırmızı işaretçi cihazın son konumunu gösterir.
							</small>
						</div>

						<div className="info fall-sensitivity-section">
							<span>Düşme Hassasiyeti (V04T):</span>
						<div className="fall-sensitivity-wrapper">
							<div className="fall-sensitivity-slider-container">
								<input
									type="range"
									min="1"
									max="6"
									value={fallSensitivity}
									onChange={(e) => setFallSensitivity(parseInt(e.target.value))}
									className="fall-sensitivity-slider"
								/>
								<div className="fall-sensitivity-labels">
									<span className="sensitivity-label">1</span>
									<span className="sensitivity-label">2</span>
									<span className="sensitivity-label">3</span>
									<span className="sensitivity-label">4</span>
									<span className="sensitivity-label">5</span>
									<span className="sensitivity-label">6</span>
								</div>
							</div>
							<div className="fall-sensitivity-value">
								<span className="sensitivity-current">{fallSensitivity}</span>
								<span className="sensitivity-desc">
									{fallSensitivity <= 2 ? "Düşük Hassasiyet" :
										fallSensitivity <= 4 ? "Orta Hassasiyet" :
											"Yüksek Hassasiyet"}
								</span>
							</div>
							<div className="fall-sensitivity-btns">
								<Button
									variant="success"
									onClick={async () => {
										try {
											setUpdatingFallSensitivity(true);
											setError("");
											setSuccess("");

											const response = await fetch(
												"https://app.vivasmartcare.com/api/v04t-update-fall-sensitivity",
												{
													method: "POST",
													body: JSON.stringify({
														deviceId: deviceID,
														fallSensitivity: fallSensitivity,
													}),
													headers: { "Content-Type": "application/json" },
												}
											);

											const data = await response.json();

											if (response.ok) {
												setSuccess(
													data.message || "Düşme hassasiyeti başarıyla güncellendi."
												);
												setTimeout(() => {
													fetchData();
												}, 1000);
											} else {
												setError(
													data.error ||
													"Düşme hassasiyeti güncellenirken bir hata oluştu"
												);
											}
										} catch (error) {
											console.error("Düşme hassasiyeti güncelleme hatası:", error);
											setError("Bağlantı hatası. Lütfen tekrar deneyin.");
										} finally {
											setUpdatingFallSensitivity(false);
										}
									}}
									disabled={updatingFallSensitivity}
									className="btn-update-fall-sensitivity"
								>
									{updatingFallSensitivity ? (
										<>
											<span
												className="spinner-border spinner-border-sm me-2"
												role="status"
												aria-hidden="true"
											></span>
											Güncelleniyor...
										</>
									) : (
										"Hassasiyeti Güncelle"
									)}
								</Button>
							</div>
						</div>
						<small className="text-muted">
							Düşme algılama hassasiyetini ayarlayın. 6 = En düşük (sadece güçlü düşmeleri algılar), 1 = En yüksek (hafif düşmeleri de algılar)
						</small>
					</div>
					</>
				)}
				{(brand === "V04T" || brand === "Vivistar") && (
					<div className="info measurement-schedule-section">
						<span>Otomatik Ölçüm Zamanlama (V04T):</span>
						<div className="falldown-toggle-wrapper">
							<div className="falldown-toggle-buttons">
								<Button
									variant={scheduleEnabled ? "success" : "outline-success"}
									onClick={() => setScheduleEnabled(true)}
									className="btn-falldown-on"
								>
									Aç
								</Button>
								<Button
									variant={!scheduleEnabled ? "danger" : "outline-danger"}
									onClick={() => setScheduleEnabled(false)}
									className="btn-falldown-off"
								>
									Kapat
								</Button>
							</div>
							<div className="falldown-status">
								<span className={`status-indicator ${scheduleEnabled ? 'status-on' : 'status-off'}`}>
									{scheduleEnabled ? '● Aktif' : '○ Pasif'}
								</span>
							</div>
						</div>

						{scheduleEnabled && (
							<div className="schedule-settings">
								<div className="schedule-measurements">
									<span className="schedule-label">Ölçüm Tipleri:</span>
									<div className="schedule-checkboxes">
										<label className="schedule-check-label">
											<input
												type="checkbox"
												checked={measureHeartRate}
												onChange={(e) => setMeasureHeartRate(e.target.checked)}
											/>
											<span>Kalp Atışı / Tansiyon / SpO2</span>
										</label>
										<label className="schedule-check-label">
											<input
												type="checkbox"
												checked={measureTemperature}
												onChange={(e) => setMeasureTemperature(e.target.checked)}
											/>
											<span>Sıcaklık</span>
										</label>
									</div>
								</div>

								<div className="schedule-mode">
									<span className="schedule-label">Zamanlama Modu:</span>
									<div className="schedule-checkboxes">
										<label className="schedule-check-label">
											<input
												type="radio"
												name="scheduleType"
												checked={scheduleType === "interval"}
												onChange={() => setScheduleType("interval")}
											/>
											<span>Belirli Aralıklarla</span>
										</label>
										<label className="schedule-check-label">
											<input
												type="radio"
												name="scheduleType"
												checked={scheduleType === "times"}
												onChange={() => setScheduleType("times")}
											/>
											<span>Belirli Saatlerde</span>
										</label>
									</div>
								</div>

								{scheduleType === "interval" && (
									<div className="schedule-interval">
										<span className="schedule-label">Ölçüm Aralığı:</span>
										<Form.Select
											value={scheduleInterval}
											onChange={(e) => setScheduleInterval(parseInt(e.target.value))}
											className="schedule-interval-select"
										>
											<option value={15}>Her 15 dakika</option>
											<option value={30}>Her 30 dakika</option>
											<option value={60}>Her 1 saat</option>
											<option value={120}>Her 2 saat</option>
											<option value={240}>Her 4 saat</option>
										</Form.Select>
									</div>
								)}

								{scheduleType === "times" && (
									<div className="schedule-times">
										<span className="schedule-label">Ölçüm Saatleri:</span>
										<div className="schedule-time-input">
											<Form.Control
												type="time"
												value={newTime}
												onChange={(e) => setNewTime(e.target.value)}
												className="schedule-time-field"
											/>
											<Button
												variant="outline-primary"
												onClick={() => {
													if (newTime && !scheduleTimes.includes(newTime)) {
														setScheduleTimes([...scheduleTimes, newTime].sort());
														setNewTime("");
													}
												}}
												disabled={!newTime}
												className="schedule-time-add-btn"
											>
												Ekle
											</Button>
										</div>
										{scheduleTimes.length > 0 ? (
											<div className="schedule-time-tags">
												{scheduleTimes.map((time) => (
													<span key={time} className="schedule-time-tag">
														{time}
														<span
															className="schedule-time-remove"
															onClick={() => setScheduleTimes(scheduleTimes.filter((t) => t !== time))}
														>
															&times;
														</span>
													</span>
												))}
											</div>
										) : (
											<small className="text-muted">Henüz saat eklenmedi.</small>
										)}
									</div>
								)}

								<div className="fall-sensitivity-btns">
									<Button
										onClick={async () => {
											try {
												setSavingSchedule(true);
												setError("");
												setSuccess("");
												const response = await fetch("https://app.vivasmartcare.com/api/v04t-update-measurement-schedule", {
													method: "POST",
													headers: { "Content-Type": "application/json" },
													body: JSON.stringify({
														deviceId: deviceID,
														enabled: scheduleEnabled,
														type: scheduleType,
														intervalMinutes: scheduleInterval,
														times: scheduleTimes,
														measurements: {
															heartRate: measureHeartRate,
															temperature: measureTemperature,
														},
													}),
												});
												const data = await response.json();
												if (response.ok) {
													setSuccess(data.message || "Ölçüm zamanlama ayarı kaydedildi.");
													setTimeout(() => setSuccess(""), 3000);
												} else {
													setError(data.error || "Zamanlama kaydedilemedi.");
												}
											} catch (err) {
												console.error("Zamanlama kaydetme hatası:", err);
												setError("Bağlantı hatası. Lütfen tekrar deneyin.");
											} finally {
												setSavingSchedule(false);
											}
										}}
										disabled={savingSchedule}
										className="btn-update-fall-sensitivity"
									>
										{savingSchedule ? (
											<>
												<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												Kaydediliyor...
											</>
										) : (
											"Zamanlama Ayarını Kaydet"
										)}
									</Button>
								</div>
							</div>
						)}
						<small className="text-muted">
							Saatte otomatik olarak ölçüm yapılmasını sağlar. Ayar her gün geçerlidir. Sadece bağlı cihazlara komut gönderilir.
						</small>
					</div>
				)}

				{(brand === "V04T" || brand === "Vivistar") && (
					<div className="info device-note">
						<span>Cihaz SIM Telefon Numarası:</span>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							value={simPhoneNumber}
							showMask
							onChange={(e) => setSimPhoneNumber(e.target.value)}
							className="phone-input"
						/>
					</div>
				)}

				<div className="info device-note">
					<span>Cihaz Notları:</span>
					<Form.Control
						type="text"
						required
						value={deviceNote}
						onChange={(e) => setDeviceNote(e.target.value)}
					/>
				</div>
				<div className="button-wrapper">
					<Button
						variant="primary"
						onClick={updateDevice}
						disabled={updating}
						className="btn-save"
					>
						{updating ? (
							<>
								<span
									className="spinner-border spinner-border-sm me-2"
									role="status"
									aria-hidden="true"
								></span>
								Güncelleniyor...
							</>
						) : (
							"Kaydet - Güncelle"
						)}
					</Button>
					{/* <Button
            variant="danger"
            onClick={() => {
              const userConfirmed = window.confirm(
                "Cihaz kalıcı olarak silinecektir. Emin misiniz?"
              );

              if (userConfirmed) {
                deleteDevice();
              }
            }}
          >
            Cihazı Sil
          </Button> */}
				</div>
			</div>
		</div>
	);
};

export default DeviceDetailScreen;
